import React, {useState} from 'react';
import {Drawer, makeStyles} from "@material-ui/core";
import Icon from '@material-ui/icons/Add';
import Button from '@mui/material/Button';
import ProveedorSocioEditar from './ProveedorSocioEdit'

const useStyles = makeStyles((theme) => ({
    paper: {
        width: '28%'
    }
}));

export const BtnEditarSocio = ({record}) => {

    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const handleDrawerOpen = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button variant="contained" size={"small"} color="primary" onClick={() => setOpen(!open)}>
                <Icon/>
                Editar
            </Button>
            <Drawer
                classes={{paper: classes.paper}}
                variant="persistent"
                anchor="right"
                open={open}
            >
                <div>
                    <h3>Editar Socio</h3>
                </div>
                <ProveedorSocioEditar
                    record={record}
                    callbackCloseDrawer={handleDrawerOpen}
                />

            </Drawer>
        </div>
    )
};
export default BtnEditarSocio;